import { actions } from '@/modules/SuiviFactures/store/modules/SuiviFacturesEnRetard/actions';
import { state, SuiviFacturesEnRetardState } from '@/modules/SuiviFactures/store/modules/SuiviFacturesEnRetard/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { mutations } from './mutations';
import { getters } from './getters';

const module: Module<SuiviFacturesEnRetardState, RootState> = {
    state,
    actions,
    mutations,
    getters,
};

export default module;
export type { SuiviFacturesEnRetardState };
